import * as React from "react";

// reducer stuff
import {ITranslatedComponent} from "../redux/reducers/generalReducer";
import {connect} from "react-redux";

// i18n
import {translate} from 'react-i18next';

// semantic
import {Dimmer, Loader} from 'semantic-ui-react';
import {compose} from "redux";
import {withRouter, RouteComponentProps} from "react-router";
import {toast} from "react-toastify";
import {selectLoadingMessages} from "../redux/selectors";
import {IReduxState} from "src/redux/IReduxState";

interface IMapStateToProps {
    loadingMessages: String[] | undefined;
}

export interface ICommonViewProps extends ITranslatedComponent { }

interface IOwnProps {
    className?: string;
    viewContainerContentAlternateClass?: string;
}

interface IViewContainerProps extends
    IOwnProps,
    ICommonViewProps,
    IMapStateToProps,
    RouteComponentProps<any> { }

class ViewContainer extends React.Component<IViewContainerProps> {

    componentDidMount(): void {
        this.props.history.listen(() => {
            toast.dismiss();
        });
    }

    render() {
        let className: string = this.props.className !== undefined ? ' ' + this.props.className : '';

        let loadingMessages = this.props.loadingMessages;
        let isLoading: boolean = loadingMessages !== undefined && loadingMessages.length > 0;
        let loadingMsg = "";
        if (loadingMessages) {
            loadingMessages.forEach((value: string, idx: number) => {
                if (idx > 0)
                    loadingMsg += ", ";
                loadingMsg += value;
            });
        }
        if (loadingMsg.length > 1) {
            loadingMsg = loadingMsg.charAt(0).toUpperCase() + loadingMsg.substr(1);
        }

        return (
            <div className={"view-container" + className}>
                <Dimmer active={isLoading}>
                    <Loader className='loader-content'>{loadingMsg}</Loader>
                </Dimmer>
                {this.props.children}
            </div>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    loadingMessages: selectLoadingMessages(state)
});

export default compose<React.ComponentType<IOwnProps>>(
    translate("SIDEBAR"),
    connect<IMapStateToProps>(mapStateToProps),
    withRouter,
)(ViewContainer);



// WEBPACK FOOTER //
// ./src/views/ViewContainer.tsx